import { createCrudActions } from '../utils/crudGenerator';
import moment from 'moment';
import { axios } from "../connection/ConnectionHandler";

const formatUsers = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.name} ${item.surname}`,
    value: item._id,
    last_login: item.last_login && moment(item.last_login),
    // Formatear campos de horario
    schedule: item.schedule ? {
      morning: {
        start: item.schedule.morning?.start ? moment(item.schedule.morning.start, 'HH:mm') : null,
        end: item.schedule.morning?.end ? moment(item.schedule.morning.end, 'HH:mm') : null,
      },
      afternoon: {
        start: item.schedule.afternoon?.start ? moment(item.schedule.afternoon.start, 'HH:mm') : null,
        end: item.schedule.afternoon?.end ? moment(item.schedule.afternoon.end, 'HH:mm') : null,
      },
    } : null,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchUsers,
  create: createUser,
  update: updateUser,
  delete: deleteUsers
} = createCrudActions('USER', "Usuario", formatUsers);

export const setUserSickLeave = (userId, sickLeave) => async (dispatch, getState) => {
  try {
    const response = await axios.post(`user/${userId}/sickleave`, { sickLeave });
    const updatedUser = response.data;

    dispatch({ type: `UPDATE_USER`, payload: formatUsers(updatedUser) });

    const state = getState();
    if (state?.profile?._id === updatedUser._id) {
      dispatch({ type: 'SET_PROFILE', payload: updatedUser });
    }

    return response.status;
  } catch (err) {
    return err.response?.status || 500;
  }
};
